<script>
import Layout from '@layout/main'
import SectionCustom from './components/SectionCustom'
import SectionFeatures from './components/SectionFeatures'
import SectionList from './components/SectionList'
import SectionPlan from './components/SectionPlan'
import SectionSecondary from './components/SectionSecondary'
import SectionTop from './components/SectionTop'
import SectionContact from '@components/SectionContact'
import SectionCloud from './components/SectionCloud'

export default {
  components: {
    Layout,
    SectionCustom,
    SectionFeatures,
    SectionList,
    SectionPlan,
    SectionSecondary,
    SectionTop,
    SectionContact,
    SectionCloud

  },
}
</script>
<template>
  <Layout>
    <SectionTop/>
    <SectionCloud/>
    <SectionFeatures/>
    <SectionList/>
    <SectionPlan/>
    <SectionContact/>
    <SectionCustom/>
    <SectionSecondary/>
  </Layout>
</template>
<style lang="scss" module>

</style>
